import { useQuery } from "@tanstack/react-query";
import { getMySubscriptionInfo } from "../../../utils";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { updateUser } from "../../../redux/features/userStateSlice";

export enum EQueryKeys {
  MY_SUBSCRIPTION_INFO = "my-subscription-info",
}

export interface ISubscriptionInfoResponse {
  subscription?: {
    id?: string;
    paypalId?: string;
    createdAt?: string;
    expDate?: string;
    status?: string;
    plan?: {
      id?: string;
      paypalPlanId?: string;
      product?: {
        name?: string;
        hexColor?: string;
      };
    };
  };
  benefits?: unknown[];
  details?: {
    billing_info?: {
      last_payment?: {
        time?: string;
      };
      next_billing_time?: string;
      last_failed_payment?: {
        next_payment_retry_time?: string;
      };
    };
    subscriber?: {
      email_address?: string;
    };
  };
  subscriptions?: unknown[];
}

export const useMySubscriptionInfo = () => {
  const token = sessionStorage.getItem("token");

  return useQuery({
    queryKey: [EQueryKeys.MY_SUBSCRIPTION_INFO],
    queryFn: () => getMySubscriptionInfo(token),
    enabled: !!token,
  });
};

export const useMySubscriptionInfoSync = () => {
  const dispatch = useDispatch();
  const query = useMySubscriptionInfo();

  useEffect(() => {
    if (!query.data) return;

    dispatch(
      updateUser({
        subscriptionInfo: query.data,
        subscription: query.data?.subscription?.id
          ? {
            ...query.data,
            id: query.data?.subscription?.id,
            paypalSubscriptionId: query.data?.subscription?.paypalId,
            planName: query.data?.subscription?.plan?.product?.name,
            planId: query.data?.subscription?.plan?.id,
            planPaypalId: query.data?.subscription?.plan?.paypalPlanId,
            hexColor: query.data?.subscription?.plan?.product?.hexColor,
            createdAt: query.data?.subscription?.createdAt,
            expDate: query.data?.subscription?.expDate,
            status: query.data?.subscription?.status,
          }
          : null,
        benefits: query.data?.benefits ?? [],
        subscriptionDetails: query.data?.details
          ? {
            lastPayment: query.data?.details?.billing_info?.last_payment?.time,
            nextPayment: query.data?.details?.billing_info?.next_billing_time,
            nextRetryPayment: query.data?.details?.billing_info?.last_failed_payment?.next_payment_retry_time,
            subscriberEmail: query.data?.details?.subscriber?.email_address,
          }
          : null,
      }),
    );
  }, [query.data, dispatch]);

  return query;
};
